module.exports = __webpack_public_path__ + "static/media/pltlogo-white.2f88af64.webp";